import React from "react";
import { FormattedMessage } from "react-intl";
import Dashboard from "components/dashboard";

const NotFoundPage = () => (
  <Dashboard>
    <h1>
      <FormattedMessage id="app.page.404" />
    </h1>
  </Dashboard>
);

export default NotFoundPage;
